import { timeDescription } from '@/utils/timeDescription'

export function useCalculateTimeSincePost(dateCreated: number): string {
  return timeDescription(dateCreated)
}
